import { render } from "./VendorProductItemModal.vue?vue&type=template&id=b72acd44"
import script from "./VendorProductItemModal.vue?vue&type=script&lang=js"
export * from "./VendorProductItemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__